// extracted by mini-css-extract-plugin
module.exports = {"foolScreen":"FoolScreen_foolScreen__18vba","controllers":"FoolScreen_controllers__2e4ZV"};